<xemex-dialog-shell [title]="'installations.migrationReport.dialog.title' | translate">
  <div class="finding-dialog">
    <div class="finding-dialog__facts">
      <xemex-detail-field [label]="'installations.migrationReport.table.class' | translate">
        {{ 'installations.migrationReport.classes.' + finding.findingClass | translate }}
      </xemex-detail-field>
      <xemex-detail-field [label]="'installations.migrationReport.dialog.subject' | translate">
        {{ finding.subjectLabel || finding.subjectId }}
        ({{ 'installations.migrationReport.subjectTypes.' + finding.subjectType | translate }})
      </xemex-detail-field>
      <xemex-detail-field [label]="'installations.migrationReport.table.severity' | translate">
        {{ 'installations.migrationReport.severities.' + finding.severity | translate }}
      </xemex-detail-field>
      <xemex-detail-field [label]="'installations.migrationReport.table.resolution' | translate">
        {{ 'installations.migrationReport.resolutions.' + finding.resolution | translate }}
      </xemex-detail-field>
      <xemex-detail-field [label]="'installations.migrationReport.table.partner' | translate">
        {{ data.partnerName ?? '–' }}
      </xemex-detail-field>
      <xemex-detail-field [label]="'installations.migrationReport.dialog.firstSeen' | translate">
        {{ finding.firstSeenAt | date: 'medium' }}
      </xemex-detail-field>
      <xemex-detail-field [label]="'installations.migrationReport.table.lastSeen' | translate">
        {{ finding.lastSeenAt | date: 'medium' }}
      </xemex-detail-field>
      @if (finding.resolvedAt) {
        <xemex-detail-field [label]="'installations.migrationReport.dialog.resolvedAt' | translate">
          {{ finding.resolvedAt | date: 'medium' }}
        </xemex-detail-field>
      }
      @if (finding.resolvedByUserOid) {
        <xemex-detail-field [label]="'installations.migrationReport.dialog.resolvedBy' | translate">
          {{ finding.resolvedByUserOid }}
        </xemex-detail-field>
      }
    </div>

    @if (finding.note) {
      <section>
        <h3 class="finding-dialog__heading">
          {{ 'installations.migrationReport.dialog.note' | translate }}
        </h3>
        <p class="finding-dialog__text">{{ finding.note }}</p>
      </section>
    }

    <section>
      <h3 class="finding-dialog__heading">
        {{ 'installations.migrationReport.dialog.evidence' | translate }}
      </h3>
      @if (evidence.length) {
        <dl class="finding-dialog__evidence">
          @for (entry of evidence; track entry.key) {
            <dt>{{ entry.key }}</dt>
            <dd>{{ entry.value }}</dd>
          }
        </dl>
      } @else {
        <p class="finding-dialog__text">
          {{ 'installations.migrationReport.dialog.noEvidence' | translate }}
        </p>
      }
    </section>

    @if (link) {
      <a class="finding-dialog__link" [routerLink]="link" (click)="close()">
        {{ 'installations.migrationReport.dialog.resolve' | translate }}
      </a>
    }

    @if (canAcknowledge) {
      <section>
        <h3 class="finding-dialog__heading">
          {{ 'installations.migrationReport.dialog.acknowledge.title' | translate }}
        </h3>
        @if (confirming()) {
          <p class="finding-dialog__text" role="alert">
            {{ 'installations.migrationReport.dialog.acknowledge.confirm' | translate }}
          </p>
        } @else {
          <xemex-text-field
            [label]="'installations.migrationReport.dialog.acknowledge.note' | translate"
            [placeholder]="
              'installations.migrationReport.dialog.acknowledge.notePlaceholder' | translate
            "
            [required]="true"
            [ngModel]="note()"
            (ngModelChange)="note.set($event)"
          />
        }
        @if (refusal(); as shown) {
          <p class="text-text-error" role="alert">{{ shown.messageKey | translate }}</p>
        }
      </section>
    }
  </div>

  <div actions class="flex w-full items-center justify-end gap-3">
    @if (confirming()) {
      <xemex-text-button [disabled]="isSaving()" (click)="back()">
        {{ 'installations.migrationReport.dialog.acknowledge.back' | translate }}
      </xemex-text-button>
      <xemex-filled-button [loading]="isSaving()" (click)="acknowledge()">
        {{ 'installations.migrationReport.dialog.acknowledge.confirmButton' | translate }}
      </xemex-filled-button>
    } @else {
      <xemex-text-button (click)="close()">
        {{ 'general.btnClose' | translate }}
      </xemex-text-button>
      @if (canAcknowledge) {
        <xemex-filled-button [disabled]="noteMissing()" (click)="review()">
          {{ 'installations.migrationReport.dialog.acknowledge.button' | translate }}
        </xemex-filled-button>
      }
    }
  </div>
</xemex-dialog-shell>
